import { REFERRER_CODE_REGEX } from '@/lib/auth-validation'

const REFERRAL_CODE_COOKIE = 'betscycle_referrer_code'
const REFERRAL_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30

export function isValidReferralCode(code: string): boolean {
	return REFERRER_CODE_REGEX.test(code)
}

export function saveReferralCode(code: string): void {
	if (!isValidReferralCode(code)) {
		return
	}

	const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : ''
	document.cookie = `${REFERRAL_CODE_COOKIE}=${encodeURIComponent(code)}; Max-Age=${REFERRAL_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secureAttribute}`
}

export function getReferralCode(): string | null {
	const cookie = document.cookie.split('; ').find((value) => value.startsWith(`${REFERRAL_CODE_COOKIE}=`))
	if (!cookie) {
		return null
	}

	try {
		const code = decodeURIComponent(cookie.slice(REFERRAL_CODE_COOKIE.length + 1))
		return isValidReferralCode(code) ? code : null
	} catch {
		return null
	}
}

export function clearReferralCode(): void {
	const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : ''
	document.cookie = `${REFERRAL_CODE_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax${secureAttribute}`
}
